var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect, useCallback } from 'react';
export var useRangeSlider = function (_a) {
    var min = _a.min, max = _a.max, value = _a.value, onChange = _a.onChange;
    var _b = __read(useState(false), 2), hasLeftError = _b[0], setHasLeftError = _b[1];
    var _c = __read(useState(false), 2), hasRightError = _c[0], setHasRightError = _c[1];
    var _d = __read(value || [min, max], 2), left = _d[0], right = _d[1];
    var _e = __read(useState(left), 2), leftInputValue = _e[0], setLeftInputValue = _e[1];
    var _f = __read(useState(right), 2), rightInputValue = _f[0], setRightInputValue = _f[1];
    var _g = __read(useState(false), 2), setHasFocus = _g[1];
    var _h = __read(useState([
        left,
        right
    ]), 2), sliderValue = _h[0], setSliderValue = _h[1];
    var isLeftValid = typeof leftInputValue === 'number' &&
        leftInputValue >= min &&
        leftInputValue <= max &&
        leftInputValue <= rightInputValue;
    var isRightValid = typeof rightInputValue === 'number' &&
        rightInputValue <= max &&
        rightInputValue >= min &&
        rightInputValue >= leftInputValue;
    // Update the INPUT values on INPUT CHANGE
    var onLeftInputChange = useCallback(function (ev) {
        var _a;
        var inputValue = parseInt((_a = ev === null || ev === void 0 ? void 0 : ev.target) === null || _a === void 0 ? void 0 : _a.value, 10);
        setLeftInputValue(inputValue);
    }, []);
    var onRightInputChange = useCallback(function (ev) {
        var _a;
        var inputValue = parseInt((_a = ev === null || ev === void 0 ? void 0 : ev.target) === null || _a === void 0 ? void 0 : _a.value, 10);
        setRightInputValue(inputValue);
    }, []);
    // Update the SLIDER values on INPUT CHANGE **if** valid.
    useEffect(function () {
        if (isLeftValid) {
            setHasLeftError(false);
            isRightValid && setHasRightError(false);
            onChange && onChange([leftInputValue, rightInputValue]);
            setSliderValue([leftInputValue, rightInputValue]);
            return;
        }
        // We don't need errors showing for both inputs at once.
        !hasRightError && setHasLeftError(true);
    }, [leftInputValue, max, min, onChange]);
    useEffect(function () {
        if (isRightValid) {
            setHasRightError(false);
            isLeftValid && setHasLeftError(false);
            onChange && onChange([leftInputValue, rightInputValue]);
            setSliderValue([leftInputValue, rightInputValue]);
            return;
        }
        // We don't need errors showing for both inputs at once.
        !hasLeftError && setHasRightError(true);
    }, [rightInputValue, max, min, onChange]);
    return {
        hasLeftError: hasLeftError,
        hasRightError: hasRightError,
        leftInputValue: leftInputValue,
        rightInputValue: rightInputValue,
        onLeftInputChange: onLeftInputChange,
        onRightInputChange: onRightInputChange,
        setHasFocus: setHasFocus,
        setLeftInputValue: setLeftInputValue,
        setRightInputValue: setRightInputValue,
        setHasLeftError: setHasLeftError,
        setHasRightError: setHasRightError,
        sliderValue: sliderValue,
        setSliderValue: setSliderValue
    };
};
//# sourceMappingURL=useRangeSlider.js.map